import { reduxForm } from 'redux-form';
import Component from './EditBankForm';
import { validate, initialValues } from './schema';

const EditBankForm = reduxForm({
  form: 'formEditBank',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default EditBankForm;
